import { render, staticRenderFns } from "./gathering-authorization-list-item.vue?vue&type=template&id=5a22bb16&"
import script from "./gathering-authorization-list-item.vue?vue&type=script&lang=js&"
export * from "./gathering-authorization-list-item.vue?vue&type=script&lang=js&"
import style0 from "./gathering-authorization-list-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports